import { PartyNodeType } from './contract-object.types';

export class CloneParty {
  static readonly type = '[Contract.Party] Clone Party';
  constructor(public partyID: number, public copies: number = 1) {}
}

export class DeleteParty {
  static readonly type = '[Contract.Party] Delete Party';
  constructor(public partyID: number) {}
}

export class RestoreParty {
  static readonly type = '[Contract.Party] Restore Party';
  constructor(public partyID: number) {}
}

export class AddParty {
  static readonly type = '[Contract.Party] Add Party';
  constructor(public partyNodeType: PartyNodeType, public party: any) {}
}

export class UpdateParty {
  static readonly type = '[Contract.Party] Update Party';
  constructor(public party: any) {}
}

export class UpdatePartyAgreement {
  static readonly type = '[Contract.Party] Update Party Agreement';
  constructor(public party: any, public agreementValues: any) {}
}

export class ClearParty {
  static readonly type = '[Contract.Party] Clear Party';
  constructor(public partyID: number, public sync: boolean = false) {}
}

export class SetTPBillToEntity {
  static readonly type = '[Contract.Party] Set TP BillTo Entity';
  constructor(public TPBillToEntity: any) {}
}
